import { mapActions, mapGetters } from "vuex";
import { random as _random } from "lodash";
import axios from 'axios';
import StorageHelper from "Stores/helper";
import TrackingHelper from "JS/helpers/tracking";

const EVENT_CATEGORY = "Campaign";
const EVENT_NAME_FACEBOOK_TAG = "track";
const EVENT_NAME_FORM_STARTED = "Form Started";
const EVENT_NAME_FORM_COMPLETE = "Form Complete";
const EVENT_NAME_FACEBOOK_COMPLETE = "CompleteRegistration";
const EVENT_NAME_SHARE_VIA_SOCIAL = "Share via Social";
const EVENT_NAME_FOUND_LEGISLATORS = "Found Legislators";

export default {
  computed: {
    ...mapGetters({
      formStarted: "forms/started",
      firedPixels: "tracking/firedPixels",
      campaignPixelFired: "tracking/campaignPixelFired"
    })
  },

  methods: {
    ...mapActions({
      setFormStarted: "forms/started",
      setFiredPixels: "tracking/firedPixels"
    }),

    getBaseFormEventProperties() {
      return {
        "Customer ID": this.customerSettings.id,
        "Account Name": this.customerSettings.name,
        "Campaign ID": this.appSettings.id,
        "Campaign Template": this.appSettings.template,
        "Campaign Theme": this.appSettings.theme,
        "Campaign Type": this.appSettings.type,
        "Cookied In": this.appSettings.cookiedIn,
        Source: this.appSettings.source,
        Message: this.currentAction,
        "Email Opt-in": this.formValues.subscribeEmail || null,
        "Text Opt-in": this.formValues.subscribeSms || null
      };
    },

    resetTrackingState() {
      StorageHelper.setStoreFromLocalStorage(this.$store, "tracking", "CAMPAIGNS");
    },

    trackEvent(category, action, properties = {}, label = "") {
      const baseProperties = this.getBaseFormEventProperties();
      const eventProperties = { ...baseProperties, ...properties };

      TrackingHelper.trackEvent(category, action, eventProperties, label);
    },

    trackFormStartEvent() {
      if (!this.formStarted) {
        const properties = {};

        properties.Title = this.formValues.title || null;
        properties.Name = this.formValues.fullName || null;
        properties.Email = this.formValues.email || null;
        properties.Address = this.formValues.address1 || null;
        properties["Zip Code"] = this.formValues.zip5 || null;
        properties["Phone Number"] = this.formValues.phone || null;

        this.trackEvent(EVENT_CATEGORY, EVENT_NAME_FORM_STARTED, properties);
        if (typeof mixpanel !== 'undefined') {
          mixpanel.time_event(EVENT_NAME_FORM_COMPLETE);
        }

        this.setFormStarted(true);
      }
    },

    trackFormCompleteEvent() {
      this.trackEvent(EVENT_CATEGORY, EVENT_NAME_FORM_COMPLETE);

      this.trackPixelEvents();
    },

    trackFoundLegislatorsEvent() {
      this.trackEvent(EVENT_CATEGORY, EVENT_NAME_FOUND_LEGISLATORS);
    },

    trackShareViaSocial({ option }) {
      const network = option.class.includes("twitter") ? "twitter" : "facebook";
      const properties = {
        "Account Name": this.customerSettings.name,
        "Campaign ID": this.appSettings.id,
        Network: network,
        Auth: option.authEnabled
      };

      this.trackEvent(EVENT_CATEGORY, EVENT_NAME_SHARE_VIA_SOCIAL, properties);
    },

    trackPixelEvents() {
      this.trackFacebookPixelEvent();
      this.trackTwitterPixelEvent();
      this.trackGoogleAdsPixelEvent();
      this.trackDoubleClickPixelEvent();
    },

    trackTwitterPixelEvent() {

      const previouslyFired = this.campaignPixelFired('twitter', this.appSettings.id),
            twitterPixelId = this.settings.trackingPixels.twitter.id;

      if (!previouslyFired && twitterPixelId && typeof(twttr) !== 'undefined') {
        twttr.conversion.trackPid(this.settings.trackingPixels.twitter.id,
                                  {tw_sale_amount: 0, tw_order_quantity: 0});

        this.setFiredPixels({
          twitter: [this.appSettings.id]
        });
      }
    },

    trackFacebookPixelEvent() {

      const previouslyFired = this.campaignPixelFired("facebook", this.appSettings.id),
            fbPixelId = this.settings.trackingPixels.facebook.id,
            newPixel = this.settings.trackingPixels.facebook.new;

      if (!previouslyFired && fbPixelId) {
        let fired = false;

        if (newPixel && typeof(fbq) !== "undefined") {
          fbq(EVENT_NAME_FACEBOOK_TAG, EVENT_NAME_FACEBOOK_COMPLETE);
          fired = true;
        } else if (!newPixel && typeof(_fbq) !== "undefined") {
          _fbq.push([
            EVENT_NAME_FACEBOOK_TAG,
            fbPixelId,
            {'value':'0.00','currency':'USD'}
          ]);
          fired = true;
        }

        if (fired) {
          this.setFiredPixels({
            facebook: [this.appSettings.id]
          });
        }
      }
    },

    trackGoogleAdsPixelEvent() {

      const previouslyFired = this.campaignPixelFired("google", this.appSettings.id),
            pixel = this.settings.trackingPixels.googleAds.url;

      if (!previouslyFired && pixel) {
        this.trackingPixelImages.push(pixel);

        this.setFiredPixels({
          google: [this.appSettings.id]
        });
      }

    },

    trackDoubleClickPixelEvent() {
      const previouslyFired = this.campaignPixelFired("doubleClick", this.appSettings.id),
            url = this.settings.trackingPixels.doubleClick.url;

      if (!previouslyFired && url) {
        const axel = _random().toString(),
              a = axel * 10000000000000;

        this.setFiredPixels({
          doubleClick: [this.appSettings.id]
        });

        return axios.get(`${this.settings.trackingPixels.doubleClick.url}${a}?`);
      }
    }

  }
};
